import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show popup after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-139">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-2xl shadow-xl border border-brand-creamDark p-4 pr-10 max-w-sm flex items-start gap-4" data-id="element-140">
          <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-brand-gray hover:text-brand-text" data-id="element-141">
            <X className="w-4 h-4" data-id="element-142" />
          </button>

          <div className="text-3xl shrink-0 mt-1" data-id="element-143">🧘‍♀️</div>

          <div data-id="element-144">
            <p className="font-bold text-brand-text text-sm mb-0.5" data-id="element-145">
              Martina D. Verona 🇮🇹
            </p>
            <p className="text-brand-green font-bold text-xs mb-1" data-id="element-146">
              Ha acquistato YOGA PRONTA
            </p>
            <p className="text-brand-gray text-[10px] flex items-center gap-1" data-id="element-147">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" data-id="element-148"></span>
              Acquisto verificato &middot; 4 minuti fa
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}